<template>
  <div style="width: 100%; height: 100%">
    <a-collapse v-model="collapseKeys" expandIconPosition="right">
      <a-collapse-panel key="1">
        <template>
          <div slot="header" class="header-title">基本信息</div>
        </template>
        <div class="collapse-content">
          <div class="collapse-content-div1">
            <div class="collapse-content-div1-title">组件名称</div>
            <div class="collapse-content-div2-input">
              <a-input v-model="newComponent.title" placeholder="" />
            </div>
          </div>
          <div class="collapse-content-div1">
            <div class="collapse-content-div1-title">组件id</div>
            <div class="collapse-content-div2-input">
              <a-input id="component-id" v-model="newComponent.key" placeholder="" />
            </div>
          </div>

          <!-- <div class="collapse-content-div1">
          <div class="collapse-content-div1-title">对齐方式</div>
          <div
            v-for="(item, indexs) in imgList"
            :key="indexs"
            @click="valueChange(indexs)"
            :class="
              visibleValue == indexs
                ? 'img-active'
                : 'collapse-content-div1-icon'
            "
          >
            <img
              :src="visibleValue == indexs ? item.img1_c : item.img1"
              style="width: 17px; height: 17px; text-align: center"
              alt=""
            />
          </div>
        </div>
        <div class="collapse-content-div1">
          <div class="collapse-content-div1-title">内边距</div>
          <div class="collapse-content-div2-input">
            <div style="width: 45%; height: 32px">
              <a-input placeholder="" />
            </div>
            <div @click="suoChange" class="suoImg">
              <img
                :src="suoActive == true ? suo : suo_c"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
            <div style="width: 45%; height: 32px">
              <a-input placeholder="" />
            </div>
          </div>
        </div>
        <div class="collapse-content-div1">
          <div class="collapse-content-div1-title">外边距</div>
          <div class="collapse-content-div2-input">
            <div style="width: 45%; height: 32px">
              <a-input placeholder="" />
            </div>
            <div @click="suoChang" class="suoImg">
              <img
                :src="suoActiv == true ? suo : suo_c"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
            <div style="width: 45%; height: 32px">
              <a-input placeholder="" />
            </div>
          </div>
        </div>
        <div class="collapse-content-div1">
          <div class="collapse-content-div1-title">自定义尺寸</div>
          <div class="collapse-content-div2-input">
            <div style="width: 45%; height: 32px">
              <a-input placeholder="" />
            </div>
            <div @click="suoChanges" class="suoImg">
              <img
                :src="suoActives == true ? suo : suo_c"
                width="100%"
                height="100%"
                alt=""
              />
            </div>
            <div style="width: 45%; height: 32px">
              <a-input placeholder="" />
            </div>
          </div>
        </div> -->
        </div>
      </a-collapse-panel>
      <a-collapse-panel key="2">
        <template>
          <div slot="header" class="header-title">样式设置</div>
        </template>
        <a-textarea
          v-model="newComponent.note.style.css"
          class="high-setting-textarea"
          placeholder="写入css样式(例 color:black;)"
          @change="styleChange"
        />
      </a-collapse-panel>
    </a-collapse>
    <a-button @click="setComponent" class="btn-save">保存</a-button>
  </div>
</template>
<script>
import BlockComponent from "@/utils/BlockComponent.js";
import _ from "lodash";
import bus from "@/utils/Bus";

export default {
  name: "RightStyle",
  props: {
    component: {
      type: Object,
      default: new BlockComponent(),
    },
  },
  data() {
    return {
      // style: "",
      newComponent: {
        note: {
          style: {
            css: ''
          }
        }
      },
      // note: {},
      // componentInfo: {},
      visibleValue: 0,
      suoActive: true,
      suoActiv: true,
      suoActives: true,
      collapseKeys: [1, 2],
      suo: require("@/assets/edit-page/suo.png"),
      suo_c: require("@/assets/edit-page/suo_c.png"),
      imgList: [
        {
          img1: require("@/assets/edit-page/left.png"),
          img1_c: require("@/assets/edit-page/left-c.png"),
        },
        {
          img1: require("@/assets/edit-page/heng.png"),
          img1_c: require("@/assets/edit-page/heng-c.png"),
        },
        {
          img1: require("@/assets/edit-page/shu.png"),
          img1_c: require("@/assets/edit-page/shu-c.png"),
        },
        {
          img1: require("@/assets/edit-page/top.png"),
          img1_c: require("@/assets/edit-page/top-c.png"),
        },
        {
          img1: require("@/assets/edit-page/right.png"),
          img1_c: require("@/assets/edit-page/right-c.png"),
        },
        {
          img1: require("@/assets/edit-page/bottom.png"),
          img1_c: require("@/assets/edit-page/bottom-c.png"),
        },
      ],
    };
  },
  watch: {
    component: {
      handler(component) {
        console.log(`样式面板监听到props component 变化: `, component.note);
        this.newComponent = _.cloneDeep(component)
        // this.componentInfo = _.cloneDeep(component.component)
        // this.style = JSON.stringify(this.note.style)
      },
      deep: true,
    },
  },
  methods: {
    setComponent(){
      bus.$emit('update-component', this.newComponent);
      bus.$emit('save-component', this.newComponent);
    },
    styleChange(e){
      let css = _.trim(this.newComponent.note.style.css)
      if (css.substr(css.length-1,1) !== ';') {
        return;
      }
      console.log('change style', css)
      if (this.component instanceof BlockComponent) {
        // 组件页面更新
        let value = {topicDict: {}};
        value.topicDict[this.component.key] = {
          note: {
            style: {
              css: css
            }
          }
        }
        bus.$emit('post-message', value, 'update-page-data')
      } else {
        // 页面样式更新
        bus.$emit('post-message', {
          note: {
            style: {
              css
            }
          }
        }, 'update-page-data')
      }
      bus.$emit("update-component", this.newComponent);
    },
    valueChange(index) {
      this.visibleValue = index;
    },
    valueChange(index) {
      this.visibleValue = index;
    },
    suoChange() {
      this.suoActive = !this.suoActive;
    },
    suoChang() {
      this.suoActiv = !this.suoActiv;
    },
    suoChanges() {
      this.suoActives = !this.suoActives;
    },
  },
};
</script>
<style scoped>
@import "index.css";
</style>